import { Module } from '@/common/api/models/module';
import log from '@/common/utils/logger';

/**
 * Utility functions for Lecturer navigation.
 */

/**
 * Extracts the latest version from a module's version history.
 * @param module - The module object.
 * @returns The latest version string (e.g., '1.2') or '0.0' if none found.
 */
export const getLatestVersion = (module: Module): string => {
  let targetVersion = '0.0';
  try {
    const { versionHistory } = module as unknown as { versionHistory: Record<string, unknown> };
    if (versionHistory && Object.keys(versionHistory).length > 0) {
      const versions = Object.keys(versionHistory);
      versions.sort((a, b) => {
        const [aMajor, aMinor] = a.split('.').map(Number);
        const [bMajor, bMinor] = b.split('.').map(Number);
        if (aMajor !== bMajor) return bMajor - aMajor;
        return bMinor - aMinor;
      });
      if (versions.length > 0) [targetVersion] = versions;
    }
  } catch (error) {
    log.error('Error getting version history', error);
  }
  return targetVersion;
};
